import { render, staticRenderFns } from "./FitnessplanCreate.vue?vue&type=template&id=29c11c96"
import script from "./FitnessplanCreate.vue?vue&type=script&lang=js"
export * from "./FitnessplanCreate.vue?vue&type=script&lang=js"
import style0 from "./FitnessplanCreate.vue?vue&type=style&index=0&id=29c11c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
